export enum BagStatusTypeEnum {
    Unsupported = -2,
    Unknown = -1,
    Empty = 0,
    Full = 1,
    Ok = 2,
    Closed = 3,
    Blocked = 4,
    WrongPosition = 5,
    NotPresent = 6,
    Miscount = 7,
    MiscountOverridden = 8,
    FullSensorCoveredAndBagEmpty = 9,
}

export function bagStatusEnumLabel(status: BagStatusTypeEnum): string {
    switch (status) {
        case BagStatusTypeEnum.Unsupported:
            return "enum.bagStatus.unsupported";
        case BagStatusTypeEnum.Unknown:
            return "enum.bagStatus.unknown";
        case BagStatusTypeEnum.Empty:
            return "enum.bagStatus.empty";
        case BagStatusTypeEnum.Full:
            return "enum.bagStatus.full";
        case BagStatusTypeEnum.Ok:
            return "enum.bagStatus.ok";
        case BagStatusTypeEnum.Closed:
            return "enum.bagStatus.closed";
        case BagStatusTypeEnum.Blocked:
            return "enum.bagStatus.blocked";
        case BagStatusTypeEnum.WrongPosition:
            return "enum.bagStatus.wrongPosition";
        case BagStatusTypeEnum.NotPresent:
            return "enum.bagStatus.notPresent";
        case BagStatusTypeEnum.Miscount:
            return "enum.bagStatus.miscount";
        case BagStatusTypeEnum.MiscountOverridden:
            return "enum.bagStatus.miscountOverridden";
        case BagStatusTypeEnum.FullSensorCoveredAndBagEmpty:
            return "enum.bagStatus.fullSensorCoveredAndBagEmpty";

        default:
            return "common.unknown";
    }
}